<form (ngSubmit)="startAzureLogin()" [name]="id" [id]="id">
  <button type="submit" [name]="buttonId" [id]="buttonId" class="btn btn-block btn-primary btn-lg">
    {{ 'loginForm.Azure.signIn' | cxTranslate }}
  </button>
</form>
